import React from "react"

const Loading = () => <div className="inner loading">Loading...</div>

export default Loading
